// TTCN-1616: API OTP của `id` bắt buộc header X-App-Id (mỗi ứng dụng có mã OTP riêng)
const otpConfig = () => ({
  headers: { "X-App-Id": process.env.VUE_APP_OTP_APP_ID || "" },
})

const repo = (axios) => {
  return {
    getListTwoFactorUsers(payload) {
      return axios
        .get(`/api/admin/two-factor/users`, {
          params: { ...payload },
        })
        .then((res) => {
          return res
        })
        .catch((err) => {
          return err.response
        })
    },
    // Sends the target value; the API does not flip the current state
    setTwoFactorRequired(id, required) {
      return axios
        .put(`/api/admin/two-factor/users/${id}`, { required })
        .then((res) => {
          return res
        })
        .catch((err) => {
          return err.response
        })
    },
    bulkSetTwoFactorRequired({ required, userIds = [], departmentIds = [] }) {
      return axios
        .post(`/api/admin/two-factor/users/required`, {
          required,
          user_ids: userIds,
          department_ids: departmentIds,
        })
        .then((res) => {
          return res
        })
        .catch((err) => {
          return err.response
        })
    },
    // TTCN-1616: kích hoạt lại tài khoản bị khoá do nhập sai OTP (không gỡ Telegram)
    unlockTwoFactorUser(id) {
      return axios
        .post(`/api/admin/two-factor/users/${id}/unlock`)
        .then((res) => {
          return res
        })
        .catch((err) => {
          return err.response
        })
    },
    // Trạng thái gắn Telegram của user hiện tại (dùng để chờ user bấm Start bot)
    getMyTelegramStatus() {
      return axios
        .get(`/api/me/telegram`)
        .then((res) => {
          return res
        })
        .catch((err) => {
          return err.response
        })
    },
    // Step-up 2FA: gửi mã OTP Telegram cho user của token hiện tại
    requestMfaChallenge() {
      return axios
        .post(`/api/auth/otp/challenge`, {}, otpConfig())
        .then((res) => {
          return res
        })
        .catch((err) => {
          return err.response
        })
    },
    // Đổi mã OTP lấy token mới (mfa=true)
    verifyMfaCode(challengeId, code) {
      return axios
        .post(`/api/auth/otp`, { challenge_id: challengeId, code }, otpConfig())
        .then((res) => {
          return res
        })
        .catch((err) => {
          return err.response
        })
    },
    // TTCN-1616: ứng dụng gọi API OTP (header X-App-Id)
    getOtpClients() {
      return axios
        .get(`/api/admin/two-factor/clients`)
        .then((res) => {
          return res
        })
        .catch((err) => {
          return err.response
        })
    },
    createOtpClient(payload) {
      return axios
        .post(`/api/admin/two-factor/clients`, payload)
        .then((res) => {
          return res
        })
        .catch((err) => {
          return err.response
        })
    },
    updateOtpClient(id, payload) {
      return axios
        .put(`/api/admin/two-factor/clients/${id}`, payload)
        .then((res) => {
          return res
        })
        .catch((err) => {
          return err.response
        })
    },
    resendMfaCode(challengeId) {
      return axios
        .post(
          `/api/auth/otp/resend`,
          { challenge_id: challengeId },
          otpConfig(),
        )
        .then((res) => {
          return res
        })
        .catch((err) => {
          return err.response
        })
    },
  }
}
export default repo
